import { Text, Card, Textarea, Code } from "@mantine/core";
import { Link } from "wouter";

export default function JobCard({ job }) {
  var pl = job.imagePayload;
  return (
    <Card>
      {job.type} {job.subType}
      <Text c="dimmed">User</Text>
      <Link to={`/admin/users/${job.userId}`}>{job.userId}</Link>
      {pl ? (
        <div>
          <Text c="dimmed">Model</Text>
          {pl.modelName} / {pl.sampler}
          <br />
          CFG: {pl.guidanceScale} <br />
          PS: {pl.promptStrength}
          <br />
          <Text c="dimmed">Lora</Text>
          {pl.lora} @ {pl.loraStrength}
          <br />
          <Text c="dimmed">Prompt</Text>
          <Textarea disabled autosize value={pl.prompt} />
          <Text c="dimmed">Negative</Text>
          <Textarea disabled autosize value={pl.negativePrompt} />
          <Text c="dimmed">Steps</Text>
          {pl.steps}
          <br />
          Seed: {pl.seed}
          <br />
        </div>
      ) : null}
      {job.result ? (
        <Text>
          {job.result.width} x {job.result.height}
        </Text>
      ) : null}
      {job.retryCount} attempts {job.milliseconds}ms @&apos;{job.machineName}&apos;
      <Text c="dimmed" mt="xl">
        Details
      </Text>
      <Code block>{JSON.stringify(job, null, 2)}</Code>
    </Card>
  );
}
